import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { getYearLabel } from '../../../Common/Util/getYearLabel';
import { useIDCRASChartsDataContext } from './hooks/useIDCRASChartsDataContext';

export const ServicesEvolutionChart = () => {
    const { chartData } = useIDCRASChartsDataContext();

    return (
        <SimpleBars
            title="Evolução Anual de Serviços"
            subtitles={chartData.services.map((item) => getYearLabel(item.ano))}
            values={chartData.services.map(
                (item) => Number(item.servicos) || 0
            )}
        />
    );
};
